import $ from 'jquery';

function DrawerCtrl() {
	this.$button        = $('#btnDrawer,#btnDrawerClose');
	this.$target        = $('#drawer,#drawerOverlay');
	this.$targetOverlay = $('#drawerOverlay');
	this.$navi          = $('#drawerNavi');
	this.classOpen      = 'drawer-open';

	this.click  = this.click.bind(this);
	this.remove = this.remove.bind(this);
	this.add    = this.add.bind(this);

	this.init();
}

DrawerCtrl.prototype.init = function() {
	this.$button.on('click', this.click);
	this.$targetOverlay.on('click', this.remove);
}

DrawerCtrl.prototype.click = function() {
	if (this.$target.hasClass(this.classOpen)) {
		this.remove();
	} else {
		this.add();
	}
}

DrawerCtrl.prototype.remove = function() {
	this.$target.removeClass(this.classOpen);
	this.$navi.removeClass(this.classOpen);
	this.$button.removeClass(this.classOpen);
}

DrawerCtrl.prototype.add = function() {
	this.$target.addClass(this.classOpen);
	this.$navi.addClass(this.classOpen);
	this.$button.addClass(this.classOpen);
}

new DrawerCtrl();